import React from 'react'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import './index.scss'

export interface AccountPausedPopupProps {
    onClose: () => void
}
const AccountPausedPopup = ({ onClose }: AccountPausedPopupProps) => (
    <div className="account-paused-popup">
        <Popup onClose={onClose} showClose>
            <ConfirmationPopup
                title="Your account has been paused"
                onConfirm={onClose}
                onCancel={onClose}
                confirmButtonText="Send Code"
            >
                <p>
                    We've noticed it's been a while since your last login. To keep your account secure, we've paused
                    access until we can verify it's you.
                    <br />
                    <br />
                    We'll send a 6-digit code to your registered email address to get you back in.
                </p>
            </ConfirmationPopup>
        </Popup>
    </div>
)

export default AccountPausedPopup
